import Window from 'window-or-global'
import * as Sentry from '@sentry/browser'
import EventBus from '@/services/bus'
import { getDeepProperty } from '@/helpers/deepObject.js'

export const errorMessages = {
  noUrl: 'Path does not exist and we cannot make an API request :(',
  noPermissions: 'User does not have permission to make this API call'
}

/**
 * factory: FetchData
 * @param {Object} api
 *
 * returns function: fetchData
 * @param {String} method
 * @param {String | Object} url - a url string or an object with `href`
 * @param {*[]} args
 *
 * Making our API calls smart so that it will do the proper stuff required
 * to make a request off of the object and not a manually created path
 */
const FetchData = api => (method, url, args = []) => {
  let message
  let href = null
  let actionType = method
  let apiMethod = method

  if (!url) {
    // This is possible and we shouldn't even try to make a request, but log to Sentry
    Window.console.error(method, url)
    message = `${errorMessages.noUrl}`
    Sentry.captureMessage(message)
    return Promise.reject(new Error(message))
  }

  switch (method) {
    case 'get':
      href = url.href || url
      break
    case 'post':
      actionType = 'create'
      break
    case 'put':
      // Looks like the API isn't consistent, so we have update AND edit :facepalm:
      actionType = url.update ? 'update' : 'edit'
      apiMethod = 'post'
      break
    case 'patch':
      break
  }

  if (method !== 'get') {
    href = getDeepProperty(url, `${actionType}.action`)
  }

  if (!href || href === '') {
    // This is possible and we shouldn't even try to make a request but it means that the
    // user doesn't have permission to do the thing that they are trying to do
    // let's pop up an error message and send the call to Sentry
    const errorEvent = {
      key: 'No permissions',
      error: 'You do not have permission to do that.'
    }
    EventBus.$emit('SHOW_ERROR_MESSAGE', errorEvent)
    Window.console.error(method, url)
    message = `${errorMessages.noPermissions}`
    Sentry.captureMessage(message)
    return Promise.reject(new Error(message))
  }

  const resp = api[apiMethod](href, ...args)
  return resp.then(({ data }) => data)
}

export default FetchData
